//设置一个固定的key值
const KEY='Authorization'
export default {
  getToken() {
    return window.localStorage.getItem(KEY);
  },
  saveToken(token) {
    window.localStorage.setItem(KEY, token);
  },
  clearToken() {
    window.localStorage.removeItem(KEY);
  },
  getTmpToken() {
    return window.localStorage.getItem("meedu-h5-tmp-token");
  },
  saveTmpToken(token) {
    window.localStorage.setItem("meedu-h5-tmp-token", token);
  },
  clearTmpToken() {
    window.localStorage.removeItem("meedu-h5-tmp-token");
  },
  saveLoginCode(code) {
    window.localStorage.setItem("login_code", code);
  },
  getLoginCode() {
    return window.localStorage.getItem("login_code");
  },
  clearLoginCode() {
    window.localStorage.removeItem("login_code");
  },
  getBizToken() {
    return window.localStorage.getItem("meedu-user-face-bizToken");
  },
  saveBizToken(token) {
    window.localStorage.setItem("meedu-user-face-bizToken", token);
  },
  clearBizToken() {
    window.localStorage.removeItem("meedu-user-face-bizToken");
  },
  getRuleId() {
    return window.localStorage.getItem("meedu-user-face-ruleId");
  },
  saveRuleId(token) {
    window.localStorage.setItem("meedu-user-face-ruleId", token);
  },
  clearRuleId() {
    window.localStorage.removeItem("meedu-user-face-ruleId");
  },
  saveSessionLoginCode(code) {
    window.sessionStorage.setItem("login_code:" + code, code);
  },
  getSessionLoginCode(code) {
    return window.sessionStorage.getItem("login_code:" + code);
  },
  removeTokenParams(url) {
    let parseUrl = new URL(url);
    let hash = parseUrl.hash;
    let querystring = hash.split("?");
    if (querystring.length <= 1) {
      return url;
    }

    let params = querystring[1].split("&");
    if (params.length === 0) {
      return url;
    }

    let data = [];
    for (let i = 0; i < params.length; i++) {
      if (
        params[i].indexOf("token=") === -1 &&
        params[i].indexOf("login_code=") === -1 &&
        params[i].indexOf("action=") === -1
      ) {
        data.push(params[i]);
      }
    }

    let newUrl =
      parseUrl.protocol +
      "//" +
      parseUrl.host +
      parseUrl.pathname +
      querystring[0];

    if (data.length > 0) {
      newUrl += "?" + data.join("&");
    }

    return newUrl;
  },
  isMobile() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  },
  isChinaMobilePhone(phone) {
    return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(phone);
  },
  isWechatMini() {
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
      return true;
    } else {
      return false;
    }
  },
  getHMS(time) {
    const hour =
      parseInt(time / 3600) < 10
        ? "0" + parseInt(time / 3600)
        : parseInt(time / 3600);
    const min =
      parseInt((time % 3600) / 60) < 10
        ? "0" + parseInt((time % 3600) / 60)
        : parseInt((time % 3600) / 60);
    const sec =
      parseInt((time % 3600) % 60) < 10
        ? "0" + parseInt((time % 3600) % 60)
        : parseInt((time % 3600) % 60);
    return hour + ":" + min + ":" + sec;
  },
  copyright() {
    let outs = [];
    let fi = function() {
      return {
        msg: "",
        style: "",
      };
    };

    var oi = fi();
    oi.msg = "MeEdu - 在线教育培训解决方案";
    oi.style =
      "padding-top: 15px;padding-bottom:15px;line-height:30px;font-size:2rem;color:#3ca7fa";
    outs.push(oi);

    oi = fi();
    oi.msg =
      "\r\n官网：\nhttps://meedu.vip\r\n\r\nGitHub：\nhttps://github.com/qsnh/meedu\r\n\r\n使用手册：\nhttps://www.yuque.com/meedu/fvvkbf\r\n\r\n当前版本：v4.9.1\r\n";
    outs.push(oi);

    outs.map(function(x) {
      console.log("%c" + x.msg, x.style);
    });
  },
  getHost() {
    let host = window.location.protocol + "//" + window.location.host;
    let pathname = window.location.pathname;
    if (pathname && pathname !== "/") {
      host += pathname;
    }
    return host + "/#";
  },
  isWechat() {
    let ua = window.navigator.userAgent.toLowerCase();
    return /micromessenger/.test(ua);
  },
};
